export const COMMON_CURRENCY_CODES = ["USD", "CAD", "EUR", "JPY", "GBP", "CNY", "CHF", "AUD", "HKD", "SGD", "KRW", "MXN"];

export const CURRENCIES = [
  { code: "AED", name: "UAE Dirham", country: "United Arab Emirates" },
  { code: "AFN", name: "Afghani", country: "Afghanistan" },
  { code: "ALL", name: "Lek", country: "Albania" },
  { code: "AMD", name: "Armenian Dram", country: "Armenia" },
  { code: "ANG", name: "Netherlands Antillean Guilder", country: "Curaçao" },
  { code: "AOA", name: "Kwanza", country: "Angola" },
  { code: "ARS", name: "Argentine Peso", country: "Argentina" },
  { code: "AUD", name: "Australian Dollar", country: "Australia" },
  { code: "AWG", name: "Aruban Florin", country: "Aruba" },
  { code: "AZN", name: "Azerbaijan Manat", country: "Azerbaijan" },
  { code: "BAM", name: "Convertible Mark", country: "Bosnia and Herzegovina" },
  { code: "BBD", name: "Barbados Dollar", country: "Barbados" },
  { code: "BDT", name: "Taka", country: "Bangladesh" },
  { code: "BGN", name: "Bulgarian Lev", country: "Bulgaria" },
  { code: "BHD", name: "Bahraini Dinar", country: "Bahrain" },
  { code: "BIF", name: "Burundi Franc", country: "Burundi" },
  { code: "BMD", name: "Bermudian Dollar", country: "Bermuda" },
  { code: "BND", name: "Brunei Dollar", country: "Brunei" },
  { code: "BOB", name: "Boliviano", country: "Bolivia" },
  { code: "BRL", name: "Brazilian Real", country: "Brazil" },
  { code: "BSD", name: "Bahamian Dollar", country: "Bahamas" },
  { code: "BTN", name: "Ngultrum", country: "Bhutan" },
  { code: "BWP", name: "Pula", country: "Botswana" },
  { code: "BYN", name: "Belarusian Ruble", country: "Belarus" },
  { code: "BZD", name: "Belize Dollar", country: "Belize" },
  { code: "CAD", name: "Canadian Dollar", country: "Canada" },
  { code: "CDF", name: "Congolese Franc", country: "Congo" },
  { code: "CHF", name: "Swiss Franc", country: "Switzerland" },
  { code: "CLP", name: "Chilean Peso", country: "Chile" },
  { code: "CNY", name: "Chinese Yuan Renminbi", country: "China" },
  { code: "COP", name: "Colombian Peso", country: "Colombia" },
  { code: "CRC", name: "Costa Rican Colón", country: "Costa Rica" },
  { code: "CUP", name: "Cuban Peso", country: "Cuba" },
  { code: "CVE", name: "Cabo Verde Escudo", country: "Cabo Verde" },
  { code: "CZK", name: "Czech Koruna", country: "Czech Republic" },
  { code: "DJF", name: "Djibouti Franc", country: "Djibouti" },
  { code: "DKK", name: "Danish Krone", country: "Denmark" },
  { code: "DOP", name: "Dominican Peso", country: "Dominican Republic" },
  { code: "DZD", name: "Algerian Dinar", country: "Algeria" },
  { code: "EGP", name: "Egyptian Pound", country: "Egypt" },
  { code: "ERN", name: "Nakfa", country: "Eritrea" },
  { code: "ETB", name: "Ethiopian Birr", country: "Ethiopia" },
  { code: "EUR", name: "Euro", country: "European Union" },
  { code: "FJD", name: "Fiji Dollar", country: "Fiji" },
  { code: "FKP", name: "Falkland Islands Pound", country: "Falkland Islands" },
  { code: "GBP", name: "Pound Sterling", country: "United Kingdom" },
  { code: "GEL", name: "Lari", country: "Georgia" },
  { code: "GHS", name: "Ghana Cedi", country: "Ghana" },
  { code: "GIP", name: "Gibraltar Pound", country: "Gibraltar" },
  { code: "GMD", name: "Dalasi", country: "Gambia" },
  { code: "GNF", name: "Guinean Franc", country: "Guinea" },
  { code: "GTQ", name: "Quetzal", country: "Guatemala" },
  { code: "GYD", name: "Guyana Dollar", country: "Guyana" },
  { code: "HKD", name: "Hong Kong Dollar", country: "Hong Kong" },
  { code: "HNL", name: "Lempira", country: "Honduras" },
  { code: "HTG", name: "Gourde", country: "Haiti" },
  { code: "HUF", name: "Forint", country: "Hungary" },
  { code: "IDR", name: "Rupiah", country: "Indonesia" },
  { code: "ILS", name: "New Israeli Shekel", country: "Israel" },
  { code: "INR", name: "Indian Rupee", country: "India" },
  { code: "IQD", name: "Iraqi Dinar", country: "Iraq" },
  { code: "IRR", name: "Iranian Rial", country: "Iran" },
  { code: "ISK", name: "Icelandic Króna", country: "Iceland" },
  { code: "JMD", name: "Jamaican Dollar", country: "Jamaica" },
  { code: "JOD", name: "Jordanian Dinar", country: "Jordan" },
  { code: "JPY", name: "Yen", country: "Japan" },
  { code: "KES", name: "Kenyan Shilling", country: "Kenya" },
  { code: "KGS", name: "Som", country: "Kyrgyzstan" },
  { code: "KHR", name: "Riel", country: "Cambodia" },
  { code: "KMF", name: "Comorian Franc", country: "Comoros" },
  { code: "KRW", name: "Won", country: "South Korea" },
  { code: "KWD", name: "Kuwaiti Dinar", country: "Kuwait" },
  { code: "KYD", name: "Cayman Islands Dollar", country: "Cayman Islands" },
  { code: "KZT", name: "Tenge", country: "Kazakhstan" },
  { code: "LAK", name: "Lao Kip", country: "Laos" },
  { code: "LBP", name: "Lebanese Pound", country: "Lebanon" },
  { code: "LKR", name: "Sri Lanka Rupee", country: "Sri Lanka" },
  { code: "LRD", name: "Liberian Dollar", country: "Liberia" },
  { code: "LSL", name: "Loti", country: "Lesotho" },
  { code: "LYD", name: "Libyan Dinar", country: "Libya" },
  { code: "MAD", name: "Moroccan Dirham", country: "Morocco" },
  { code: "MDL", name: "Moldovan Leu", country: "Moldova" },
  { code: "MGA", name: "Malagasy Ariary", country: "Madagascar" },
  { code: "MKD", name: "Denar", country: "North Macedonia" },
  { code: "MMK", name: "Kyat", country: "Myanmar" },
  { code: "MNT", name: "Tugrik", country: "Mongolia" },
  { code: "MOP", name: "Pataca", country: "Macao" },
  { code: "MRU", name: "Ouguiya", country: "Mauritania" },
  { code: "MUR", name: "Mauritius Rupee", country: "Mauritius" },
  { code: "MVR", name: "Rufiyaa", country: "Maldives" },
  { code: "MWK", name: "Malawi Kwacha", country: "Malawi" },
  { code: "MXN", name: "Mexican Peso", country: "Mexico" },
  { code: "MYR", name: "Malaysian Ringgit", country: "Malaysia" },
  { code: "MZN", name: "Mozambique Metical", country: "Mozambique" },
  { code: "NAD", name: "Namibia Dollar", country: "Namibia" },
  { code: "NGN", name: "Naira", country: "Nigeria" },
  { code: "NIO", name: "Córdoba Oro", country: "Nicaragua" },
  { code: "NOK", name: "Norwegian Krone", country: "Norway" },
  { code: "NPR", name: "Nepalese Rupee", country: "Nepal" },
  { code: "NZD", name: "New Zealand Dollar", country: "New Zealand" },
  { code: "OMR", name: "Rial Omani", country: "Oman" },
  { code: "PAB", name: "Balboa", country: "Panama" },
  { code: "PEN", name: "Sol", country: "Peru" },
  { code: "PGK", name: "Kina", country: "Papua New Guinea" },
  { code: "PHP", name: "Philippine Peso", country: "Philippines" },
  { code: "PKR", name: "Pakistan Rupee", country: "Pakistan" },
  { code: "PLN", name: "Złoty", country: "Poland" },
  { code: "PYG", name: "Guarani", country: "Paraguay" },
  { code: "QAR", name: "Qatari Rial", country: "Qatar" },
  { code: "RON", name: "Romanian Leu", country: "Romania" },
  { code: "RSD", name: "Serbian Dinar", country: "Serbia" },
  { code: "RUB", name: "Russian Ruble", country: "Russia" },
  { code: "RWF", name: "Rwanda Franc", country: "Rwanda" },
  { code: "SAR", name: "Saudi Riyal", country: "Saudi Arabia" },
  { code: "SBD", name: "Solomon Islands Dollar", country: "Solomon Islands" },
  { code: "SCR", name: "Seychelles Rupee", country: "Seychelles" },
  { code: "SDG", name: "Sudanese Pound", country: "Sudan" },
  { code: "SEK", name: "Swedish Krona", country: "Sweden" },
  { code: "SGD", name: "Singapore Dollar", country: "Singapore" },
  { code: "SHP", name: "Saint Helena Pound", country: "Saint Helena" },
  { code: "SLE", name: "Leone", country: "Sierra Leone" },
  { code: "SOS", name: "Somali Shilling", country: "Somalia" },
  { code: "SRD", name: "Surinam Dollar", country: "Suriname" },
  { code: "SSP", name: "South Sudanese Pound", country: "South Sudan" },
  { code: "STN", name: "Dobra", country: "São Tomé and Príncipe" },
  { code: "SYP", name: "Syrian Pound", country: "Syria" },
  { code: "SZL", name: "Lilangeni", country: "Eswatini" },
  { code: "THB", name: "Baht", country: "Thailand" },
  { code: "TJS", name: "Somoni", country: "Tajikistan" },
  { code: "TMT", name: "Turkmenistan New Manat", country: "Turkmenistan" },
  { code: "TND", name: "Tunisian Dinar", country: "Tunisia" },
  { code: "TOP", name: "Pa'anga", country: "Tonga" },
  { code: "TRY", name: "Turkish Lira", country: "Turkey" },
  { code: "TTD", name: "Trinidad and Tobago Dollar", country: "Trinidad and Tobago" },
  { code: "TWD", name: "New Taiwan Dollar", country: "Taiwan" },
  { code: "TZS", name: "Tanzanian Shilling", country: "Tanzania" },
  { code: "UAH", name: "Hryvnia", country: "Ukraine" },
  { code: "UGX", name: "Uganda Shilling", country: "Uganda" },
  { code: "USD", name: "US Dollar", country: "United States" },
  { code: "UYU", name: "Peso Uruguayo", country: "Uruguay" },
  { code: "UZS", name: "Uzbekistan Sum", country: "Uzbekistan" },
  { code: "VES", name: "Bolívar Soberano", country: "Venezuela" },
  { code: "VND", name: "Dong", country: "Vietnam" },
  { code: "VUV", name: "Vatu", country: "Vanuatu" },
  { code: "WST", name: "Tala", country: "Samoa" },
  { code: "XAF", name: "CFA Franc BEAC", country: "Central Africa" },
  { code: "XCD", name: "East Caribbean Dollar", country: "Eastern Caribbean" },
  { code: "XOF", name: "CFA Franc BCEAO", country: "West Africa" },
  { code: "XPF", name: "CFP Franc", country: "French Polynesia" },
  { code: "YER", name: "Yemeni Rial", country: "Yemen" },
  { code: "ZAR", name: "Rand", country: "South Africa" },
  { code: "ZMW", name: "Zambian Kwacha", country: "Zambia" },
  { code: "ZWL", name: "Zimbabwe Dollar", country: "Zimbabwe" },
];

// ═══ WHAT A CURRENCY CODE IS — ONE ANSWER, HERE  (ZEN-658) ═══════════════════
//
// THE DEFECT THIS CLOSES. The server compares currency codes uppercased on both
// sides. About ten screens each wrote their own version of that line and the
// settle panel wrote none at all, so a row stored as `cad` was a DIFFERENT
// currency from `CAD`: its own bucket in a per-currency total, and a mixed
// selection where the server sees one currency. Nothing fails loudly when the
// two sides disagree — the screen simply answers a slightly different question
// and looks fine doing it.
//
// Nothing is wrong in the live data: it holds only CAD and USD, none mis-cased.
// This closes the door rather than repairing anything behind it.
//
// PRIOR ART, DELIBERATELY FOLLOWED. `backend/money_totals.py` is this same
// pattern applied to amounts — one place answers the question, every caller
// asks it, and the raw field is never read directly. ZEN-637 built the same
// thing privately inside `pages/DashboardSettlements.jsx`; this is its home.
//
// WHY THE FALLBACK IS AN ARGUMENT AND NOT A DEFAULT. Most currency fields
// arrive from the server already defaulted to "USD", and a screen reading one
// of those means "absent is US dollars" — `curCode(x, "USD")`. But
// `home_currency`, `repay_currency` and `reimb_currency` are genuinely optional
// on the server, where absent means NOT SET and is a different fact from US
// dollars. A hidden default would quietly turn one into the other, so each
// caller says which it means.

/**
 * The canonical form of a currency code; `fallback` when there is none.
 *
 * THE FALLBACK IS IGNORED UNLESS IT IS A STRING, and that clause is not
 * decoration. `list.map(curCode)` reads beautifully and is wrong: `Array.map`
 * hands its callback the INDEX as a second argument, so a blank entry at
 * position 1 comes back as the number 1 rather than "". Measured, not imagined
 * — `["cad", "", "usd"].map(curCode)` returned `["CAD", 1, "USD"]` while this
 * change was being reviewed. The call sites were fixed; this makes the shape
 * safe for the next person who writes it the pretty way.
 */
export const curCode = (value, fallback = "") => {
  // A FALSY VALUE IS ABSENT, which is what every `x || "USD"` this replaces
  // already meant. Canonicalising blindly turned `false` into "FALSE" and `0`
  // into "0" — truthy strings that skip the fallback and then fail the server's
  // currency check, where the old code would simply have used US dollars.
  //
  // AND A NUMBER IS NOT A CODE. An earlier draft accepted one "so as not to lose
  // data", which turned a spreadsheet cell holding the ISO NUMBER 840 into the
  // currency "840" and carried it into a tax record. The code it replaced could
  // not do that — it called .toUpperCase() and a number has none, so the import
  // stopped instead. A currency here is letters; anything else is absent and the
  // caller's fallback decides, exactly as an empty cell already does.
  const usable = typeof value === "string" && value;
  const code = usable ? String(value).trim().toUpperCase() : "";
  return code || (typeof fallback === "string" ? fallback : "");
};

/**
 * Is this US dollars?
 *
 * Absent is NOT US dollars, which is what `x !== "USD"` has always meant at the
 * three dozen places this replaces. Somewhere that means the opposite says so:
 * `isUSD(curCode(x, "USD"))`.
 */
export const isUSD = (value) => curCode(value) === "USD";

/** Are these the same currency? Two absent codes match, as they always have. */
export const sameCurrency = (a, b) => curCode(a) === curCode(b);

const NAME_BY_CODE = Object.fromEntries(CURRENCIES.map((c) => [c.code, c.name]));
export const currencyName = (code) => NAME_BY_CODE[curCode(code)] || curCode(code);

/** Set of all valid ISO codes for validation */
export const VALID_CURRENCY_CODES = new Set(CURRENCIES.map((c) => c.code));

/** Is this a currency the product knows about at all? */
export const isKnownCurrency = (value) => VALID_CURRENCY_CODES.has(curCode(value));

/**
 * A currency read from outside the app: a spreadsheet cell, or what the
 * receipt scanner found. One rule for both. (ZEN-829, Maryse's ruling A,
 * 29 Oct 2026.)
 *
 * - empty            -> US dollars, as before
 * - a code we know   -> that code ("cad" -> "CAD")
 * - anything else    -> NO currency, plus the text that could not be read.
 *   Never guessed and never cut to three letters ("dollars" was stored as DOL).
 */
export const readOutsideCurrency = (value) => {
  const text = value == null ? "" : String(value).trim();
  if (!text) return { code: "USD", unreadable: null };
  if (typeof value === "string" && isKnownCurrency(text)) return { code: curCode(text), unreadable: null };
  return { code: "", unreadable: text };
};

/** The sentence on a spreadsheet row whose currency could not be read. */
export const unreadableCurrencyMessage = (text) =>
  `Your spreadsheet says "${text}" for the currency, which is not a currency the app can read. Choose the currency for this expense.`;

/** The spreadsheet import button, when some rows wait for a currency. */
export const importButtonLabel = (readyCount, waitingCount) =>
  waitingCount ? `Import ${readyCount} ready (${waitingCount} waiting for a currency)` : `Import all (${readyCount})`;

/** After importing the ready rows, while others still wait. */
export const stillWaitingForCurrencyMessage = (waitingCount) =>
  `${waitingCount} row${waitingCount === 1 ? " is" : "s are"} still waiting for ${waitingCount === 1 ? "its currency" : "their currency"} below.`;
